import classNames from 'classnames';

import { Event } from '../../../Shared/types';
import { NameBadge } from '../../../Shared/UI/NameBadge';

export default function EventLogo({
  event,
  size = 'md',
}: {
  event: Event;
  size?: 'md' | 'lg'
}) {
  if (event.logo_url) {
    return (
      <div className={classNames(size === 'md' && 'w-8 h-8', size === 'lg' && 'w-10 h-10')}>
        <img src={event.logo_url} alt={event.title} className="block object-contain w-full h-full rounded" />
      </div>
    );
  }

  return (
    <NameBadge name={event.title} size={size} />
  );
}
